import { Box, Typography } from "@mui/material";
import { BlTextButton } from "Components/Shared/Buttons/BlTextButton";
import { useNavigate } from "Navigation/useNavigate";
import { setUnauthenticatedUrl } from "State/Auth/AuthReducer";
import { Resources, useResource } from "Translations/Resources";
import { appUrl } from "Utils/UrlUtils";
import { useDispatch } from "react-redux";

type Props = {
  returnUrl: string;
};

export const SignInPrompt = ({ returnUrl }: Props) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { t } = useResource();

  const handleSignIn = () => {
    dispatch(setUnauthenticatedUrl(returnUrl));
    navigate(appUrl("sign-in"));
  };

  return (
    <Box display="flex" justifyContent="center" gap={1}>
      <Typography>{t(Resources.Dashboard.AlreadyHaveAccount)}</Typography>
      <BlTextButton onClick={handleSignIn}>
        {t(Resources.Pages.Content.CustomerAnonymousPaymentPay.SignIn)}
      </BlTextButton>
    </Box>
  );
};
